module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centerdiv"
  }, [_c('h2', [_vm._v("出题")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-row', {
    staticClass: "rowheight"
  }, [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("类别1")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "显示到最上方的类别"
    },
    model: {
      value: (_vm.pInfo.type1),
      callback: function($$v) {
        _vm.pInfo.type1 = $$v
      },
      expression: "pInfo.type1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("类别2")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备用，尚未用到"
    },
    model: {
      value: (_vm.pInfo.type2),
      callback: function($$v) {
        _vm.pInfo.type2 = $$v
      },
      expression: "pInfo.type2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("关键词")]), _vm._v(" "), _c('el-col', {
    staticClass: "xtextleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "会显示到类别1的下方"
    },
    model: {
      value: (_vm.pInfo.keyword),
      callback: function($$v) {
        _vm.pInfo.keyword = $$v
      },
      expression: "pInfo.keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("标题")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "此处文字会显示到正文中，可写可不写，最好写上"
    },
    model: {
      value: (_vm.pInfo.title),
      callback: function($$v) {
        _vm.pInfo.title = $$v
      },
      expression: "pInfo.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("原作者")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.pInfo.author2),
      callback: function($$v) {
        _vm.pInfo.author2 = $$v
      },
      expression: "pInfo.author2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("答案类型")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "0为输入，1为单选题，2为多选题"
    },
    model: {
      value: (_vm.pInfo.atype),
      callback: function($$v) {
        _vm.pInfo.atype = $$v
      },
      expression: "pInfo.atype"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("答案标记")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "即显示在输入答案前的提示，同时也是选择题选项"
    },
    model: {
      value: (_vm.pInfo.amark),
      callback: function($$v) {
        _vm.pInfo.amark = $$v
      },
      expression: "pInfo.amark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("答案是否数值")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "数值为1，字符为0，逗号分隔，，如果是多个输入，需要全写，如三个是1,1,1"
    },
    model: {
      value: (_vm.pInfo.aisnumber),
      callback: function($$v) {
        _vm.pInfo.aisnumber = $$v
      },
      expression: "pInfo.aisnumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("答案格式")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案格式，如输入一个整数，输入一个字符，输入一个小数，保留两位小数等，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo.aformat),
      callback: function($$v) {
        _vm.pInfo.aformat = $$v
      },
      expression: "pInfo.aformat"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("答案")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "答案，多个用逗号分隔"
    },
    model: {
      value: (_vm.pInfo.answer),
      callback: function($$v) {
        _vm.pInfo.answer = $$v
      },
      expression: "pInfo.answer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("keyword2")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用于生成静态页面的keywords，尽量多填"
    },
    model: {
      value: (_vm.pInfo.keyword2),
      callback: function($$v) {
        _vm.pInfo.keyword2 = $$v
      },
      expression: "pInfo.keyword2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("description")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "description"
    },
    model: {
      value: (_vm.pInfo.description),
      callback: function($$v) {
        _vm.pInfo.description = $$v
      },
      expression: "pInfo.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "labright",
    attrs: {
      "span": 6
    }
  }, [_vm._v("动画js名称")]), _vm._v(" "), _c('el-col', {
    staticClass: "textleft",
    attrs: {
      "span": 18
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "只写名称如12k_pid_6,forward_1等，不加.js"
    },
    model: {
      value: (_vm.pInfo.animateJSNames),
      callback: function($$v) {
        _vm.pInfo.animateJSNames = $$v
      },
      expression: "pInfo.animateJSNames"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('input', {
    ref: "file",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange
    }
  })]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v("上传图片到服务器")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.commit
    }
  }, [_vm._v("提交题目")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.commit2knowledge
    }
  }, [_vm._v("提交本题到知识点,需先提交为题目")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('div', {
    attrs: {
      "id": "app-4"
    }
  }, [_c('ol', _vm._l((_vm.imgFileList), function(fn) {
    return _c('li', {
      key: fn.url
    }, [_vm._v("\n              " + _vm._s(fn.url) + "\n            ")])
  }))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px auto",
      "max-width": "98%",
      "height": "98%"
    },
    attrs: {
      "id": "standalone-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "toolbar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "calc(100vh - 230px)"
    },
    attrs: {
      "id": "editor"
    }
  })])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ce07a05"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CreateProblem.vue
// module id = 636
// module chunks = 0